const service =  {
  name: 'Wetlands',
  label: 'Wetlands',
  permissionId: 'wetlands',
  iconComponent: 'RiverIce',
  showCoordinates: true,
  hideDatetimeSlider: true,
  disableMainDate: true,
  data: [
  ],
  layers: [
    {
      name: 'Wetlands',
      label: 'Wetland classification',
      opacity: 'fill-opacity',
      datetimeId: 'Wetlands',
      open: true
    }
    ],
  locations: [
    {
      name: 'Newfoundland',
      latitude: 48,
      longitude: -55,
      zoom: [12],
    }
    ]
}

export default service



// WEBPACK FOOTER //
// ./src/services/Wetlands.js